<template>
    <div class="contain remove-padding-margin">
        <div class="contain remove-padding-margin" id="setproduksi">
            <div class="fixed-top bg-white">
                <div class="nav-center pageDefault">
                    <div class="row set-row d-flex">
                        <div class="remove-padding navbar-icon-left" @click="back">
                            <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                        </div>
                        <div class="text-center remove-padding flex-1 font-weight-600">
                            Pengaturan Proses Produksi
                        </div>
                        <div class="navbar-icon-right remove-padding">

                        </div>
                    </div>
                </div>
            </div>
            <main class="">
                <div class="flex-100">
                    <div class="flex-1 pad-top-50">
                        <div class="text-head mar-top-20 mar-bottom-16 add-padding-default">
                            <div class="font-16 color-33333 line-height-25 letter-space-002">
                                Anda dapat mengatur apakah outlet ini melakukan aktivitas produksi.
                            </div>
                        </div>
                        <div class="form-group add-padding-default" v-if="this.detailoutletproduksi.workshop_idworkshop===null">
                            <label class="remove-margin font-14 line-height-21 letter-space-002 color-6f7">Proses Produksi</label>
                            <select :disabled="!validateAccess('outletProductionProces.update')" class="form-control" v-model="selected" v-on:change="showmodal">
                                <option v-for="produksi in options" v-bind:value="produksi.value">
                                    {{produksi.text}}
                                </option>
                            </select>
                        </div>

                        <div class="form-group" v-else>
                            <div class="add-padding-default">
                                <label class="remove-margin">Proses Produksi</label>
                                <select :disabled="!validateAccess('outletProductionProces.update')" class="form-control" v-model="selected" v-on:change="showmodal">
                                    <option v-for="produksi in options" v-bind:value="produksi.value">
                                        {{produksi.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="pembatas mar-top-15 mar-bottom-16"></div>
                            <div class="row add-padding-default remove-margin" @click="gototahapanworkshop">
                                <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                    <div class="text-footer">Tahapan Produksi</div>
                                    <div class="color-6f7 font-14 letter-space-002 line-height-21">{{isidata}} Tahapan proses produksi</div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-2 remove-padding set-img">
                                    <img src="../../assets/icons/chevron-right1.svg" alt="">
                                </div>
                            </div>
                            <div class="pembatas mar-top-15"></div>
                            <div class="row remove-margin add-padding-default mar-top-20 mar-bottom-20">
                                <div class="col-md-2 col-sm-2 col-2 remove-padding">
                                    <img src="../../assets/icons/arrow-up-right.svg" alt="">
                                </div>
                                <div class="col-md-10 col-sm-10 col-10 remove-padding" @click="validateAccess('workshop.read') && gotodetailworkshop()">
                                    <div class="text-footer">Ke Detail Workshop</div>
                                    <div class="color-6f7 font-14 letter-space-002 line-height-21">Workshop {{namaworkshop}}</div>
                                </div>
                            </div>
                            <div class="border-bottom"></div>
                        </div>
                    </div>
                </div>
            </main>
	
	        <div class="modal fade" id="modal-ubah-proses-produksi" role="dialog">
		        <div class="modal-dialog modal-lg  bani-modal">
			        <div class="modal-content">
				        <div class="modal-header">
					        <div class="nav-btn kiri"></div>
					        <h5 class="navbar-title text-center">Ubah Proses Produksi</h5>
					        <div class="nav-btn kanan tutup">
						        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
					        </div>
				        </div>
				        <div class="modal-body">
					        <div>Apakah Anda yakin ingin mengubah Proses Produksi di outlet <b>{{namaoutlet}}</b>? </div>
					        <div class="mar-top-20">Mengubah proses produksi mungkin akan <b>mengubah alur kerja</b> kasir dan karyawan workshop.</div>
					        <div class="color-206CF mar-top-8">Pelajari selengkapnya <span><img src="" alt=""></span></div>
				        </div>
				        <div class="modal-footer">
					        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
					                id="tidak" @click="showStatusWorkshop">Ya, Ubah
					        </button>
					        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
					                id="proses" @click="showDetailWorkshop">Ya, Ubah
					        </button>
				        </div>
			        </div>
		        </div>
	        </div>
	        
<!--            <div class="modal fade" id="tidak" role="dialog">-->
<!--                <div class="modal-dialog modal-lg  bani-modal">-->
<!--                    <div class="modal-content">-->
<!--                        <div class="modal-header">-->
<!--                            <div class="nav-btn kiri"></div>-->
<!--                            <h5 class="navbar-title text-center">Ubah Proses Produksi</h5>-->
<!--                            <div class="nav-btn kanan tutup">-->
<!--                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="modal-body">-->
<!--                            <div>Apakah Anda yakin ingin mengubah Proses Produksi di outlet {{namaoutlet}}? </div>-->
<!--                            <div class="mar-top-20">Mengubah proses produksi mungkin akan mengubah alur kerja kasir dan karyawan workshop.</div>-->
<!--                            <div class="color-206CF mar-top-8">Pelajari selengkapnya <span><img src="" alt=""></span></div>-->
<!--                        </div>-->
<!--                        <div class="modal-footer">-->
<!--                            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"-->
<!--                                    @click="pisahworkshop">Ya, Ubah-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="modal fade" id="proses" role="dialog">-->
<!--                <div class="modal-dialog modal-lg  bani-modal">-->
<!--                    <div class="modal-content">-->
<!--                        <div class="modal-header">-->
<!--                            <div class="nav-btn kiri"></div>-->
<!--                            <h5 class="navbar-title text-center">Ubah Proses Produksi</h5>-->
<!--                            <div class="nav-btn kanan tutup">-->
<!--                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="modal-body">-->
<!--                            <div>Apakah Anda yakin ingin mengubah Proses Produksi di outlet {{namaoutlet}}? </div>-->
<!--                            <div class="mar-top-20">Mengubah proses produksi mungkin akan mengubah alur kerja kasir dan karyawan workshop.</div>-->
<!--                            <div class="color-206CF mar-top-8">Pelajari selengkapnya <span><img src="" alt=""></span></div>-->
<!--                        </div>-->
<!--                        <div class="modal-footer">-->
<!--                            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"-->
<!--                                    @click="cekconnection">Ya, Buat Workshop-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <DetailWorkshopSetprod v-bind:class="{hidesection:!isdetailworkshop}" v-on:gosetproduksi="isdetailsetprod" v-bind:setidworkshop="idworkshop" ref="detailworkshopproduksi"/>
        <TahapanSetProduksi v-bind:class="{hidesection:!istahapanworkshop}" v-on:gosetproduksi="isdetailsetprod" v-bind:setidworkshop="idworkshop" ref="tahapanworkshopproduksi"/>
        <DataWorkshopProduksi v-bind:class="{hidesection:!isdataworkshop}" v-on:gosetproduksi="isdetailsetprod" v-on:gotodetailworkshop="gotodetailworkshopdata"
                              v-bind:setidoutlet="setidoutlet" v-bind:setidworkshop="idworkshop" ref="dataworkshopproduksi"/>
	    <StatusWorkshop v-bind:class="{hidesection:!isStatusWorkshop}"
	                    :dataoutlet="detailoutletproduksi"
	                    ref="statusworkshopref"
	                    @showdetailoutlet="hideStatusWorkshop"
	                    @pisahkanWorkshop="pisahworkshop"
	                    @sembunyikanWorkshop="sembunyikanWorkshop"
	    />
	    <DetailProduksi v-bind:class="{hidesection:!isDetailProduksi}"
	                    :dataoutlet="detailoutletproduksi"
	                    @showdetailoutlet="hideDetailWorkshop"
	                    ref="detailproduksiref"
	                    @buatworkshop="cekconnection"
	    />
    </div>
</template>

<script>
    import DetailWorkshopSetprod from "./DetailWorkshopSetprod";
    import TahapanSetProduksi from "./TahapanSetProduksi";
    import DataWorkshopProduksi from "./DataWorkshopProduksi";
    import StatusWorkshop from "../../components/production/production-process/StatusWorkshop";
    import DetailProduksi from "../../components/production/production-process/DetailProduksi";
    
    export default {
        name: "SetProduction",
        props:['setidoutlet'],
        components:{
            DetailWorkshopSetprod,TahapanSetProduksi,DataWorkshopProduksi, StatusWorkshop, DetailProduksi
        },
        data(){
          return{
              selected:'',
	          previousSelected: '',
              options:[
                  {text:'Ada proses produksi', value:'ada'},
                  {text:'Tidak ada proses produksi', value:'tidak ada'}
              ],
              workshop: {},
              isdetailworkshop:false,
              istahapanworkshop:false,
              isdataworkshop:false,
	          isStatusWorkshop:false,
	          isDetailProduksi: false,
              isidata:'',
              namaoutlet:'',
              namaworkshop:'',
              detailoutletproduksi:{},
              idoutlet:this.setidoutlet,
              idworkshop:'',
              requestHeaders: {
                  headers: {
                      'Authorization': 'Bearer ' + localStorage.getItem('token'),
                  }
              },
          }
        },
        mounted(){
            this.idoutlet = this.$route.params.idoutlet
        },
        methods: {
            back() {
                this.$emit('isdetail')
            },
            isdetailsetprod(){
                this.isdetailworkshop = false;
                this.istahapanworkshop=false;
                this.isdataworkshop=false;
                $('#setproduksi').show();
                this.detailoutlet()
            },
            gotodetailworkshop(idworkshop){
                this.isdetailworkshop = true;
                $('#setproduksi').hide();
                this.$refs.detailworkshopproduksi.getdetailworkshopsetprod(idworkshop);
                this.$refs.detailworkshopproduksi.getkotasetprod(idworkshop);
            },
            gotodetailworkshopdata(idworkshop){
                this.isdetailworkshop = true;
                this.isdataworkshop=false;
                $('#setproduksi').hide();
                this.$refs.detailworkshopproduksi.getdetailworkshopsetproddata(idworkshop);
                this.$refs.detailworkshopproduksi.getkotasetprod(idworkshop);
            },
            gototahapanworkshop(idworkshop){
                this.istahapanworkshop = true;
                $('#setproduksi').hide();
                this.$refs.tahapanworkshopproduksi.getChecklistsetprod(idworkshop);
                this.$refs.tahapanworkshopproduksi.getTahapansetprod(idworkshop);
            },
            gotodataworkshop(){
                this.isdataworkshop = true;
                this.isDetailProduksi = false
                $('#setproduksi').hide();
                this.$refs.dataworkshopproduksi.getkotaworkshopproduksi();
                this.$refs.dataworkshopproduksi.cekValidateworkshopproduksi();
            },
            showmodal(){
	            $("#modal-ubah-proses-produksi").modal("show")
                if(this.selected==='ada'){
                    // $('#proses').modal('show')
	                $('#proses').show();
                    $('#tidak').hide();
                }else{
                    // $('#tidak').modal('show')
	                $('#proses').hide();
	                $('#tidak').show();
                }
                this.selected = this.previousSelected
            },

            async cekconnection(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi',this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                           this.gotodataworkshop()
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                        } else {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.$toast.error(response.data.msg)
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async detailoutlet(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.setidoutlet,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var outlet = response.data.data[0];
                            this.detailoutletproduksi = response.data.data[0];
                            this.namaoutlet = outlet.nama;
                            $('#loadingPage').hide();
	
                            $("#setproduksi").show();
	                        this.isdetailworkshop = false
	                        this.istahapanworkshop = false
	                        this.isdataworkshop = false
	                        this.isStatusWorkshop = false
	                        this.isDetailProduksi = false
                            
                            if(this.detailoutletproduksi.workshop_idworkshop===null){
                                this.selected='tidak ada';
                            }else{
                                this.idworkshop=this.detailoutletproduksi.workshop_idworkshop;
                                this.selected='ada';
                                this.detailworkshop();
                            }
	                        this.previousSelected = this.selected
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async detailworkshop(){
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner');
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + this.idworkshop + '&idowner=' + idowner, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.workshop = response.data.data.workshop;
                            this.namaworkshop = this.workshop.nama;
                            this.isidata = response.data.data.tahapan.length;
                            this.isClicked = false;
                            $('#loadingPage').removeClass('overlayLoading');
                        }
                    } else {
                    	this.$toast.error(response.data.msg)
	                    $('#loadingPage').removeClass('overlayLoading');
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
	        
	        showStatusWorkshop() {
                $("#setproduksi").hide();
                this.isStatusWorkshop = true;
                this.$refs.statusworkshopref.getDetailWorkshop();
	        },
	        hideStatusWorkshop() {
		        $("#setproduksi").show();
		        this.isStatusWorkshop = false;
	        },
	        
	        showDetailWorkshop() {
		        $("#setproduksi").hide();
		        this.isDetailProduksi = true;
		        setTimeout(() => {
			        this.$refs.detailproduksiref.getSingleWorkshop()
		        }, 100)
	        },
	        hideDetailWorkshop() {
		        $("#setproduksi").show();
		        this.detailoutlet()
		        this.isDetailProduksi = false;
		        this.isdataworkshop = false;
	        },

            async pisahworkshop(hideworkshop = false, workshop= {}){
                try {
                    const pisahdataworkshop = new FormData;
                    pisahdataworkshop.append('idoutlet', this.setidoutlet);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/pisahkan_workshop_gabung_dengan_outlet', pisahdataworkshop,this.requestHeaders);
                    if(res.data.status===true){
	                    if (hideworkshop) {
		                    this.hideworkshop(workshop)
	                    } else {
	                    	this.$toast.success(res.data.msg)
		                    this.detailoutlet()
	                    }
                    }else{
                    	this.$toast.error(res.data.msg)
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
	        async hideworkshop(workshop) {
		        try {
			        const delworkshop =new FormData()
			        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/delete_workshop?idowner=' + workshop.owner_idowner + "&idworkshop=" + workshop.idworkshop, delworkshop, this.requestHeaders)
			        if(response.data.status===true){
			        	this.$toast.success(response.data.msg)
				        this.detailoutlet()
			        }else{
			        	this.$toast.error(response.data.msg)
			        }
		        }  catch (e) {
		        	this.$catch_error_response(e)
			        $('#loadingPage').hide();
			        $('#loadingPage').removeClass('overlayLoading');
		        }
	        },
	        sembunyikanWorkshop(workshop) {
            	this.pisahworkshop(true, workshop)
	        }
        }
    }
</script>

<style scoped>
    .text-head{
        line-height: 21px;
        align-items: center;
        letter-spacing: -0.01em;
        color: #333333;
    }
    .text-footer{
        font-weight: 600;
        line-height: 25px;
        font-size: 16px;
        color: #000000;
    }

    .set-img{
        display: flex;
        justify-content: flex-end;
    }

    .hidesection {
        display: none;
    }
</style>